import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CheckoutCartState from "../Data/ADICheckoutCartState";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: CheckoutCartState = {
    isLoading: false,
    cart: null,
    alternateShipTo: null,
};

const reducer = {
    "Custom/LoadCheckoutCart": (draft: Draft<CheckoutCartState>, action: { result: CheckoutCartState }) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteCheckoutCart": (draft: Draft<CheckoutCartState>, action: { cart: CartModel }) => {
        draft.isLoading = false;
        draft.cart = action.cart;
    },

    "Custom/updateAlternateShip": (draft: Draft<CheckoutCartState>, action: { result: CheckoutCartState }) => {
        draft.alternateShipTo = action.result.alternateShipTo;
    },

    "Custom/PaymentMethod": (draft: Draft<CheckoutCartState>, action: { paymentMethod: string }) => {
        draft.paymentMethod = action.paymentMethod;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
